import script from "./TransactionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionModal.vue?vue&type=script&setup=true&lang=js"

import "./TransactionModal.vue?vue&type=style&index=0&id=e42c54f4&lang=scss"

const __exports__ = script;

export default __exports__